var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height grey lighten-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[(_vm.title)?_c('h1',{staticClass:"text-h1"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('h2',{staticClass:"mt-4 text-h5"},[_vm._v(_vm._s(_vm.message))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }